export const removeCountryCode = (phoneNumber: string): string => {
  if (phoneNumber && phoneNumber.startsWith('+1')) {
    return phoneNumber.slice(2);
  }
  return phoneNumber;
};
